// src/styles/displayHeaderStyles.js
import { styled, withStyle } from 'baseui';
import { HeadingLarge as BaseHeadingLarge, ParagraphSmall } from 'baseui/typography';

export const DisplayParagraphSmall = styled(BaseHeadingLarge, ({ $theme, $palette }) => ({
  color: `${$palette.contentPrimary} !important`,
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px',
  lineHeight: '1',
  ':last-child': {
    marginBottom: '0px',
  },
}));

export const LeftInfoText = withStyle(DisplayParagraphSmall, ({ $theme, $palette }) => ({
  marginLeft: '1vw',
  fontSize: '3.5dvh !important',
}));

export const RightInfoText = withStyle(DisplayParagraphSmall, ({ $theme, $palette }) => ({
  marginLeft: '1vw',
  fontSize: '2.5dvh !important',
  fontFamily: 'monospace',
}));

export const DisplayHeadingLarge = styled(BaseHeadingLarge, ({ $theme, $palette }) => ({
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px',
  lineHeight: '1',
}));


export const InfoHeaderArea = styled('div', ({ $theme, $palette }) => ({
  display: 'grid',
  gridTemplateColumns: '0.25fr 0.5fr 0.25fr',
  gridTemplateRows: 'auto auto',
  gridTemplateAreas: `
    "title title title"
    "left center right"
  `,
  gap: '0.5vw',
  padding: '1.6dvh',
  backgroundColor: $palette.backgroundSecondary,
  color: $palette.contentPrimary,
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  borderBottomColor: $palette.borderOpaque,
  
  [`@media screen and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    gridTemplateColumns: '1fr',
    gridTemplateAreas: `
      "title"
      "center"
    `,
  },
}));

export const TournamentTitleLayout = styled('div', ({ $theme, $palette }) => ({
  gridArea: 'title',
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  width: '100%',
  paddingTop: '0px',
  paddingBottom: '0px',
  gap: '0px',
}));

export const TournamentNameText = withStyle(DisplayHeadingLarge, ({ $theme, $palette }) => ({
  gridColumn: '2 / 3',
  fontSize: '4.0dvh !important',
  lineHeight: '1.5 !important',
  color: `${$palette.contentPrimary} !important`,
  textAlign: 'center',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const HeaderActionsContainer = styled('div', ({ $theme}) => ({
  gridColumn: '3 / 4',
  justifySelf: 'end',
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale300
}));

export const InfoBlock = styled('div', ({ $theme, $palette }) => ({
  color: $palette.contentPrimary,
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${$palette.borderOpaque}`,
  borderRadius: '10px',
  backgroundColor: $palette.backgroundPrimary,
}));

export const InfoHeaderLeftCell = withStyle(InfoBlock, ({ $theme, $palette }) => ({
  gridArea: 'left',
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  columnGap: '0px',
  alignItems: 'center',
  rowGap: '0px',
  [`@media screen and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    display: 'none',
  },
}));

export const InfoLabelCell = withStyle(LeftInfoText, ({ $theme }) => ({
  gridColumn: '1 / 2',
  textAlign: 'center',
  paddingRight: $theme.sizing.scale100,
}));

export const InfoValueCell = withStyle(LeftInfoText, ({ $theme }) => ({
  gridColumn: '2 / 3',
  textAlign: 'center',
}));

export const InfoHeaderCenterCell = withStyle(InfoBlock, ({ $theme, $palette }) => ({
  gridArea: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '0px',
  paddingBottom: '0px',
}));

export const InfoHeaderRightCell = withStyle(InfoBlock, ({ $theme, $palette }) => ({
  gridArea: 'right',
  alignItems: 'flex-start',
  justifyContent: 'space-around',
  position: 'relative',
  [`@media screen and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    display: 'none',
  },
}));

export const InfoHeaderLevelText = withStyle(DisplayParagraphSmall, ({ $theme, $palette }) => ({
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px',
  padding: '0px',
  textAlign: 'center',
  color: `${$palette.contentPrimary} !important`,
  fontSize: '8.0dvh !important',
  lineHeight: '1.2 !important',
  width: 'auto',
  display: 'block',
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    fontSize: '5.0dvh !important',
  },
}));

export const InfoHeaderTimerText = withStyle(DisplayHeadingLarge, ({ $theme, $palette }) => ({
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px',
  padding: '0px 0px 1dvh 0px',
  fontSize: '22.0dvh !important',
  lineHeight: '1',
  letterSpacing: '-0.05em',
  color: `${$palette.contentPrimary} !important`,
  width: 'auto',
  display: 'block',
  textAlign: 'center',
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    fontSize: '12.0dvh !important',
  },
}));

export const StartsAtContainer = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
}));

export const StartsAtLabelText = styled(ParagraphSmall, ({ $theme, $palette }) => ({
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '1dvh',
  marginLeft: '0px',
  fontSize: '6.0dvh !important',
  color: `${$palette.contentPrimary} !important`,
  lineHeight: 1.2,
}));

export const StartsAtDateText = styled(BaseHeadingLarge, ({ $theme, $palette }) => ({
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '1dvh',
  marginLeft: '0px',
  fontSize: '11.0dvh !important',
  color: `${$palette.contentPrimary} !important`,
  lineHeight: 1,
  letterSpacing: '-0.05em',
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    fontSize: '8.0dvh !important',
  },
}));

export const StartsAtTimeText = styled(BaseHeadingLarge, ({ $theme, $palette }) => ({
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '1dvh',
  marginLeft: '0px',
  fontSize: '11.0dvh !important',
  color: `${$palette.contentPrimary} !important`,
  lineHeight: 1,
  letterSpacing: '-0.05em',
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    fontSize: '8.0dvh !important',
  },
}));

export const EmbeddedQrCodeContainer = styled('div', ({ $theme }) => ({
  position: 'absolute',
  bottom: $theme.sizing.scale300,
  right: $theme.sizing.scale300,
  padding: $theme.sizing.scale200,
  backgroundColor: 'white',
  borderRadius: $theme.borders.radius200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
}));

export const createHeaderActionButtonOverrides = (palette) => ({
  BaseButton: {
    style: ({ $theme }) => ({
      color: `${palette.contentPrimary} !important`,
      backgroundColor: `${$theme.colors.buttonMinimalFill} !important`,
      ':hover': {
        backgroundColor: `${$theme.colors.buttonMinimalFillHover} !important`,
        color: `${$theme.colors.buttonMinimalTextHover} !important`,
      },
      ':active': {
        backgroundColor: `${$theme.colors.buttonMinimalFillActive} !important`,
        color: `${$theme.colors.buttonMinimalTextActive} !important`,
      },
    }),
  },
});
